import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';


export default function About() {

	useEffect(() => {
		document.title = "About Page: RedPanda Fencing"
	}, []);

	return <div style={{textAlign:"center"}}> 
	
	<h1>RedPanda Website Draft</h1> 
	<br></br>
	<p>Work in Progress</p> 
	
	<p>Lefty</p>
	
	<p>Jay</p>
	
	<p>Denny</p>
	
	<p>Brandon</p>
	
	<p>Varun?!</p>
	
	<p>Ruthvik?!</p>
	
	<p>Anyone else?!</p>
	
	
	
	</div> 
	



}